<template>
  <div>
    <div class="bd-header bd-header_championat">
      <div class="bd-header__menu" @click="shift()">
        <svg height="100" viewBox="-38 -38 100 100" width="100" xmlns="http://www.w3.org/2000/svg" v-if="!isMobile" v-bind:svg-inline="''" v-bind:class="'bd-svg-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M-33-23h90c1.377 0 2.559.488 3.535 1.465S62-19.379 62-18s-.488 2.559-1.465 3.535S58.377-13 57-13h-90c-1.379 0-2.559-.488-3.535-1.465S-38-16.621-38-18s.488-2.559 1.465-3.535S-34.379-23-33-23zm0 60h90c1.377 0 2.559.488 3.535 1.465S62 40.623 62 42s-.488 2.559-1.465 3.535S58.377 47 57 47h-90c-1.379 0-2.559-.488-3.535-1.465S-38 43.377-38 42s.488-2.559 1.465-3.535S-34.379 37-33 37zm0-30h90c1.377 0 2.559.488 3.535 1.465S62 10.621 62 12s-.488 2.559-1.465 3.535S58.377 17 57 17h-90c-1.379 0-2.559-.488-3.535-1.465S-38 13.379-38 12s.488-2.559 1.465-3.535S-34.379 7-33 7z"/></svg>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 123.5 102.7" v-else="" v-bind:svg-inline="''" v-bind:class="'bd-svg-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M47.6 98.1c2.9 2.9 7.7 2.9 10.6 0 2.9-2.9 2.9-7.7 0-10.6L29.4 58.7h83.5c4.1 0 7.5-3.4 7.5-7.5s-3.4-7.5-7.5-7.5H29.4l28.8-28.8c2.9-2.9 2.9-7.7 0-10.6C56.7 2.8 54.8 2 52.9 2s-3.8.7-5.3 2.2L6 45.8c-1.4 1.4-2.2 3.3-2.2 5.3S4.6 55 6 56.4l41.6 41.7z"/></svg>
      </div>
      <div class="bd-header__title bd-ht">
        <img class="bd-ht__img" src="/pages/championat/img/logo.svg" alt="">
      </div>
    </div>
    <div class="bd-feed bd-feed_championat">
      <div class="bd-championat">
        <ul class="bd-championat-menu">
          <li class="bd-championat-menu__el">Новости</li>
          <li class="bd-championat-menu__el">Матч-центр</li>
          <li class="bd-championat-menu__el">Статистика</li>
        </ul>
        <div class="bd-championat-baner">
          <img :src="pageData.baners[0].img" alt="" class="bd-championat-baner__img">
          <div class="bd-championat-baner__data">
            <div class="bd-championat-baner__category">{{ pageData.baners[0].category }}</div>
            <div class="bd-championat-baner__title">{{ pageData.baners[0].title }}</div>
          </div>
        </div>

        <div class="bd-championat-news">
          <div
            v-for="item in pageData.news"
            :key="item.title"
            class="bd-championat-news__el">
            <div>
              <span class="bd-championat-news__time">12:01</span>
              <span class="bd-championat-news__title">{{ item.title }}</span>
            </div>
            <buzzCode
              v-if="item.title === 'Дзагоев полетел с ЦСКА в Уфу'"
              @ready="ready"
              :id="id">
            </buzzCode>
          </div>
        </div>
        <div class="bd-championat-more">Все новости</div>
        <div class="bd-championat-when">
          <div class="bd-championat-when__el">Вчера</div>
          <div class="bd-championat-when__el bd-championat-when__el_active">Сейчас</div>
          <div class="bd-championat-when__el">Сегодня</div>
          <div class="bd-championat-when__el">Завтра</div>
        </div>
        <div class="bd-championat-footer">
          <span class="bd-championat-footer__el">Главная</span>
          <span class="bd-championat-footer__el">Полная версия</span>
          <span class="bd-championat-footer__el bd-championat-footer__el_block">
            &copy; Чемпионат, 2000&mdash;2017
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import buzzCode from '@/components/buzzCode.vue';
import { isMobile } from 'mobile-device-detect';

export default {
  name: 'championat',
  data() {
    return {
      pageData:
        {
          baners: [
            {
              title: 'Ставка на неизвестное. Как идиотские трансферы тащат «Барсу» на дно',
              category: 'Футбол',
              img: '/pages/championat/img/baner0.jpg',
            },
            {
              title: 'Жуткий Донингтон. Авария сплотила весь автоспортивный мир',
              category: 'Авто',
              img: '/pages/championat/img/baner2.jpg',
            },
            {
              title: '«Монако» и ещё 9 команд, которых никто не ждал в полуфиналах ЛЧ',
              category: 'Футбол',
              img: '/pages/championat/img/baner3.jpg',
            },
            {
              title: '«Просто сбросили с трибун». Почему в Аргентине на дерби убили фаната',
              category: 'Футбол',
              img: '/pages/championat/img/baner4.jpg',
            },
          ],
          news: [
            {
              title: 'Формула-1 окрасится в цвета «Спартака» в честь 95-летия клуба. Фоторепортаж',
            },
            {
              title: '«Спартак» объявил о назначении Епанчинцева главным тренером',
            },
            {
              title: 'Маррей в трёх сетах проиграл Рамосу в 1/8 финала «Мастерса» в Монте-Карло',
            },
            {
              title: 'Матч «Спартак» — «Зенит» стал самым популярным в текущем сезоне Премьер-Лиги',
            },
            {
              title: 'Кошшои не указал в рапорте, что футболисты «Баварии» вошли в судейскую',
            },
            {
              title: 'Почеттино считает «Челси» фаворитом полуфинального матча Кубка Англии',
            },
            {
              title: 'Гоффен сломил сопротивление Тима в 3-м круге «Мастерса-1000» в Монте-Карло',
            },
            {
              title: 'Дзагоев полетел с ЦСКА в Уфу',
            },
            {
              title: 'Форвард «Ойлерз» Драйзайтль оштрафован на $ 2,5 тыс. за колющий удар',
            },
            {
              title: 'Долгова вышла в финал ЧЕ по дзюдо в весе до 48 кг',
            },
            {
              title: 'С. Алонсо: «Баскония» должна вернуться домой с одной победой над ЦСКА',
            },
            {
              title: 'Бэйл готовится к матчу с «Барселоной» в общей группе «Реала»',
            },
            {
              title: 'Шесть «стволов», которые были никому не нужны в Counter-Strike 1.6',
            },
            {
              title: '«Баффало» уволил главного тренера Байлсму и генерального менеджера Мюррея',
            },
            {
              title: 'Финкельштейн: если бы M-1 хотела подписать Антонью Силву, то уже сделала бы это',
            },
            {
              title: 'Синицина и Кацалапов выиграли произвольный танец на командном чемпионате мира',
            },
            {
              title: 'Лидер юниорской сборной России Иван Мирошниченко пропустит ЮЧМ по решению властей США',
            },
            {
              title: 'Мишина и Галлямов выиграли короткую программу на командном чемпионате мира',
            },
            {
              title: 'Определились все полуфиналисты ЛЕ, «Авангард» вышел в финал КХЛ. Главное к утру',
            },
            {
              title: 'Панарин уступает только Макдэвиду и Драйзайтлю по показателю «очки за матч» в сезоне НХЛ',
            },
            {
              title: 'Панарин: «Рейнджерс» поймали свою игру, но всё равно не идеально. Больше пасуйте на меня',
            },
          ],
        },
      isMobile,
    };
  },
  props: {
    id: {
      type: String,
    },
  },
  components: {
    buzzCode,
  },
  methods: {
    ready() {
      this.$emit('ready');
    },
    shift() {
      if (isMobile) {
        this.$emit('shift');
      }
    },
  },
};
</script>

<style scoped lang='stylus'>

fontSize(size, lineHeight)
  font-size ((size*0.0625)rem)
  line-height ((lineHeight/size)em)

img
  display block
  width 100%
  height auto

.bd
  &-header
    transition margin .4s
    display flex
    flex-flow row nowrap
    position fixed
    z-index 99997
    align-items center
    align-content space-around
    width 100%
    height 60px
    &_hide
      margin-top -60px
    &__menu
      width 30px
      height 20px
      margin 15px
      svg
        width 100%
        height 100%
        display block
    &__title
      width 100%
      text-align center
  &-feed
    box-sizing border-box
    width 100%
    height 100%
    min-height 100%
    padding-top 60px
  &-header
    &_championat
      align-items center
      background-color black
      font-size 0
      & ^[1]__menu
        fill white
      & ^[1]__title
        text-align left
      .bd-ht__img
        display inline-block
        width 143px
        height auto
    &__menu
      -webkit-tap-highlight-color transparent
      outline none
  &-svg-icon
    -webkit-tap-highlight-color transparent
    outline none
  &-championat
    font-family Arial, sans-serif
    text-align left
    &-menu
      display table
      width 100%
      margin 0
      padding 0
      background-color #e9e9e9
      border-bottom 1px solid #cecece
      &__el
        display table-cell
        height 26px
        fontSize(14,26)
        text-align center
        color #424242
    &-baner
      position relative
      padding 10px 10px 0 10px
      &__img
        display block
        width 100%
        height auto
      &__data
        position absolute
        bottom 0
        left 0
        margin 0 10px
        display block
        overflow hidden
      &__category
        display inline-block
        padding 0 10px
        background-color #6c8c9f
        fontSize(11,20)
        text-transform uppercase
        color white
      &__title
        padding 10px 15px
        border-top 1px solid #6c8c9f
        background-color rgba(black, .7)
        fontSize(18,20)
        font-weight bold
        color white
    &-news
      padding 10px 0
      &__el
        display table
        margin 0 10px
      &__time
        display table-cell
        width 35px
        padding 8px 0
        fontSize(14,16)
        color #8e979f
      &__title
        display table-cell
        padding-left 10px
        fontSize(16,18)
        color #333
    &-more
      margin 10px
      padding 6px 16px
      background-color #eee
      fontSize(16,18)
      text-align center
      color #333
    &-when
      box-sizing border-box
      width 100%
      padding 0 10px
      font-size 0
      &__el
        box-sizing border-box
        display inline-block
        width 25%
        padding 5px 0
        border 2px solid white
        background-color #545f68
        fontSize(14,18)
        text-align center
        color white
        &_active
          background-color #ed6a36
          &:after
            content ""
            position relative
            top 2px
            display block
            width 0
            height 0
            margin 0 auto
            margin-bottom -8px
            border-left 14px solid transparent
            border-right 14px solid transparent
            border-top 8px solid #ed6a36
    &-footer
      margin-top 20px
      padding 10px
      background-color #3d4246
      &__el
        margin-right 6%
        fontSize(14,30)
        color white
        &_block
          display block

</style>
